export const TOOLBOX_NAMESPACE = 'toolbox';
export const EDITOR_NAMESPACE = 'editor';
export const COMPONENTS = 'components';
export const SIGN_IN = 'signIn';
export const TUTORIAL = 'tutorial';
